export class ContingencyDetail {
  cost: string;
  description: string;
  totalCosts: any;
}
